export default {"src":"/_next/static/media/tpad-logo-img.5eaa1084.svg","height":2000,"width":2000,"blurWidth":0,"blurHeight":0};